import React from 'react';
import { NavLink } from 'react-router-dom';
import { VERSION } from '../components/configuracion/config';

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-dark text-light pt-4 mt-auto border-top">
      <div className="container">
        <div className="row">

          {/* Empresa */}
          <div className="col-md-4 mb-3">
            <h5 className="fw-bold">Transportes Medellín Castilla</h5>
            <p className="small text-secondary">
              Soluciones de transporte confiables, seguras y eficientes.
            </p>
          </div>

          {/* Navegación */}
          <div className="col-md-4 mb-3">
            <h6 className="fw-bold">Navegación</h6>
            <ul className="list-unstyled small">
              
              <li>
                <NavLink
                  to="/inicio"
                  className={({ isActive }) =>
                    isActive
                      ? "text-warning text-decoration-none"
                      : "text-light text-decoration-none"
                  }
                >
                  Inicio
                </NavLink>
              </li>

              <li>
                <NavLink
                  to="/minutas"
                  className={({ isActive }) =>
                    isActive
                      ? "text-warning text-decoration-none"
                      : "text-light text-decoration-none"
                  }
                >
                  Minutas
                </NavLink>
              </li>



            </ul>
          </div>

          {/* Contacto */}
          <div className="col-md-4 mb-3">
            <h6 className="fw-bold">Contacto</h6>
            <ul className="list-unstyled small text-secondary">
              <li>📍 Medellín, Colombia</li>
            </ul>
          </div>

        </div>

        <hr className="border-secondary" />

        {/* Bottom */}
        <div className="text-center small pb-2">
          © {year} Todos los derechos reservados. Versión {VERSION}
        </div>
      </div>
    </footer>
  );
}

export default Footer;